import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

export const useManageContextFileTagsStyles = makeStyles({
  nameCell: {
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  descriptionCell: {
    display: "block",
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontSize: designTokens.fontSize.sm,
    color: designTokens.neutral[600],
  },
  errorAlert: {
    padding: designTokens.spacing[3],
    backgroundColor: projectIqTokens.rustBg,
    color: projectIqTokens.rust,
    borderRadius: designTokens.borderRadius.md,
    marginBottom: designTokens.spacing[4],
  },
  dialogField: {
    marginBottom: designTokens.spacing[4],
  },
});
